// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-0613af2d] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.input-field[data-v-0613af2d] {
  position: relative;
  width: 100%;
  border-radius: var(--border-radius-large);
  margin-block-start: 6px;
}
.input-field__main-wrapper[data-v-0613af2d] {
  height: var(--default-clickable-area);
  position: relative;
}
.input-field--disabled[data-v-0613af2d] {
  opacity: 0.4;
  filter: saturate(0.4);
}
.input-field__input[data-v-0613af2d] {
  margin: 0;
  padding-inline: 12px 6px;
  height: var(--default-clickable-area) !important;
  width: 100%;
  font-size: var(--default-font-size);
  text-overflow: ellipsis;
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  border: var(--border-width-input, 2px) solid var(--color-border-maxcontrast);
  border-radius: var(--border-radius-large);
  cursor: pointer;
  -webkit-appearance: textfield !important;
  -moz-appearance: textfield !important;
}
.input-field__input--label-outside[data-v-0613af2d] {
  padding-block: 0;
}
.input-field__input[data-v-0613af2d]:active:not([disabled]), .input-field__input[data-v-0613af2d]:hover:not([disabled]), .input-field__input[data-v-0613af2d]:focus:not([disabled]) {
  border-width: var(--border-width-input-focused, 2px);
  border-color: var(--color-main-text) !important;
  box-shadow: 0 0 0 2px var(--color-main-background) !important;
}
.input-field__input:focus + .input-field__label[data-v-0613af2d], .input-field__input:hover:not(:placeholder-shown) + .input-field__label[data-v-0613af2d] {
  color: var(--color-main-text);
}
.input-field__input[data-v-0613af2d]:not(:focus, .input-field__input--label-outside)::placeholder {
  opacity: 0;
}
.input-field__input[data-v-0613af2d]:focus {
  cursor: text;
}
.input-field__input[data-v-0613af2d]:disabled {
  cursor: default;
}
.input-field__input[data-v-0613af2d]:focus-visible {
  box-shadow: unset !important;
}
.input-field__input--leading-icon[data-v-0613af2d] {
  padding-inline-start: var(--default-clickable-area);
}
.input-field__input--trailing-icon[data-v-0613af2d] {
  padding-inline-end: var(--default-clickable-area);
}
.input-field__input--success[data-v-0613af2d] {
  border-color: var(--color-success) !important;
}
.input-field__input--success[data-v-0613af2d]:focus-visible {
  box-shadow: rgb(248, 250, 252) 0px 0px 0px 2px, var(--color-primary-element) 0px 0px 0px 4px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
}
.input-field__input--error[data-v-0613af2d] {
  border-color: var(--color-error) !important;
}
.input-field__input--error[data-v-0613af2d]:focus-visible {
  box-shadow: rgb(248, 250, 252) 0px 0px 0px 2px, var(--color-primary-element) 0px 0px 0px 4px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
}
.input-field__input--pill[data-v-0613af2d] {
  border-radius: var(--border-radius-pill);
}
.input-field__label[data-v-0613af2d] {
  position: absolute;
  margin-inline: 14px 0;
  max-width: fit-content;
  inset-block-start: 11px;
  inset-inline: 0;
  color: var(--color-text-maxcontrast);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick), background-color var(--animation-quick) var(--animation-slow);
}
.input-field__label--leading-icon[data-v-0613af2d] {
  margin-inline-start: var(--default-clickable-area);
}
.input-field__label--trailing-icon[data-v-0613af2d] {
  margin-inline-end: var(--default-clickable-area);
}
.input-field__input:focus + .input-field__label[data-v-0613af2d], .input-field__input:not(:placeholder-shown) + .input-field__label[data-v-0613af2d] {
  inset-block-start: -10px;
  line-height: 1.5;
  font-size: 13px;
  font-weight: 500;
  border-radius: var(--default-grid-baseline) var(--default-grid-baseline) 0 0;
  background-color: var(--color-main-background);
  padding-inline: 5px;
  margin-inline-start: 9px;
  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick);
}
.input-field__input:focus + .input-field__label--leading-icon[data-v-0613af2d], .input-field__input:not(:placeholder-shown) + .input-field__label--leading-icon[data-v-0613af2d] {
  margin-inline-start: 41px;
}
.input-field__icon[data-v-0613af2d] {
  position: absolute;
  height: var(--default-clickable-area);
  width: var(--default-clickable-area);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
}
.input-field__icon--leading[data-v-0613af2d] {
  inset-block-end: 0;
  inset-inline-start: 2px;
}
.input-field__icon--trailing[data-v-0613af2d] {
  inset-block-end: 0;
  inset-inline-end: 2px;
}
.input-field__trailing-button.button-vue[data-v-0613af2d] {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: var(--border-radius-large);
}
.input-field__trailing-button--pill.button-vue[data-v-0613af2d] {
  border-radius: var(--border-radius-pill);
}
.input-field__helper-text-message[data-v-0613af2d] {
  padding-block: 4px;
  display: flex;
  align-items: center;
}
.input-field__helper-text-message__icon[data-v-0613af2d] {
  margin-inline-end: 8px;
}
.input-field__helper-text-message--error[data-v-0613af2d] {
  color: var(--color-error-text);
}
.input-field__helper-text-message--success[data-v-0613af2d] {
  color: var(--color-success-text);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcInputField-CyNcetxP.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,wBAAwB;EACxB,gDAAgD;EAChD,WAAW;EACX,mCAAmC;EACnC,uBAAuB;EACvB,8CAA8C;EAC9C,6BAA6B;EAC7B,4EAA4E;EAC5E,yCAAyC;EACzC,eAAe;EACf,wCAAwC;EACxC,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oDAAoD;EACpD,+CAA+C;EAC/C,6DAA6D;AAC/D;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mDAAmD;AACrD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,iIAAiI;AACnI;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,iIAAiI;AACnI;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,kNAAkN;AACpN;AACA;EACE,kDAAkD;AACpD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4EAA4E;EAC5E,8CAA8C;EAC9C,mBAAmB;EACnB,wBAAwB;EACxB,mJAAmJ;AACrJ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-0613af2d] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.input-field[data-v-0613af2d] {\n  position: relative;\n  width: 100%;\n  border-radius: var(--border-radius-large);\n  margin-block-start: 6px;\n}\n.input-field__main-wrapper[data-v-0613af2d] {\n  height: var(--default-clickable-area);\n  position: relative;\n}\n.input-field--disabled[data-v-0613af2d] {\n  opacity: 0.4;\n  filter: saturate(0.4);\n}\n.input-field__input[data-v-0613af2d] {\n  margin: 0;\n  padding-inline: 12px 6px;\n  height: var(--default-clickable-area) !important;\n  width: 100%;\n  font-size: var(--default-font-size);\n  text-overflow: ellipsis;\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  border: var(--border-width-input, 2px) solid var(--color-border-maxcontrast);\n  border-radius: var(--border-radius-large);\n  cursor: pointer;\n  -webkit-appearance: textfield !important;\n  -moz-appearance: textfield !important;\n}\n.input-field__input--label-outside[data-v-0613af2d] {\n  padding-block: 0;\n}\n.input-field__input[data-v-0613af2d]:active:not([disabled]), .input-field__input[data-v-0613af2d]:hover:not([disabled]), .input-field__input[data-v-0613af2d]:focus:not([disabled]) {\n  border-width: var(--border-width-input-focused, 2px);\n  border-color: var(--color-main-text) !important;\n  box-shadow: 0 0 0 2px var(--color-main-background) !important;\n}\n.input-field__input:focus + .input-field__label[data-v-0613af2d], .input-field__input:hover:not(:placeholder-shown) + .input-field__label[data-v-0613af2d] {\n  color: var(--color-main-text);\n}\n.input-field__input[data-v-0613af2d]:not(:focus, .input-field__input--label-outside)::placeholder {\n  opacity: 0;\n}\n.input-field__input[data-v-0613af2d]:focus {\n  cursor: text;\n}\n.input-field__input[data-v-0613af2d]:disabled {\n  cursor: default;\n}\n.input-field__input[data-v-0613af2d]:focus-visible {\n  box-shadow: unset !important;\n}\n.input-field__input--leading-icon[data-v-0613af2d] {\n  padding-inline-start: var(--default-clickable-area);\n}\n.input-field__input--trailing-icon[data-v-0613af2d] {\n  padding-inline-end: var(--default-clickable-area);\n}\n.input-field__input--success[data-v-0613af2d] {\n  border-color: var(--color-success) !important;\n}\n.input-field__input--success[data-v-0613af2d]:focus-visible {\n  box-shadow: rgb(248, 250, 252) 0px 0px 0px 2px, var(--color-primary-element) 0px 0px 0px 4px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n}\n.input-field__input--error[data-v-0613af2d] {\n  border-color: var(--color-error) !important;\n}\n.input-field__input--error[data-v-0613af2d]:focus-visible {\n  box-shadow: rgb(248, 250, 252) 0px 0px 0px 2px, var(--color-primary-element) 0px 0px 0px 4px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n}\n.input-field__input--pill[data-v-0613af2d] {\n  border-radius: var(--border-radius-pill);\n}\n.input-field__label[data-v-0613af2d] {\n  position: absolute;\n  margin-inline: 14px 0;\n  max-width: fit-content;\n  inset-block-start: 11px;\n  inset-inline: 0;\n  color: var(--color-text-maxcontrast);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  pointer-events: none;\n  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick), background-color var(--animation-quick) var(--animation-slow);\n}\n.input-field__label--leading-icon[data-v-0613af2d] {\n  margin-inline-start: var(--default-clickable-area);\n}\n.input-field__label--trailing-icon[data-v-0613af2d] {\n  margin-inline-end: var(--default-clickable-area);\n}\n.input-field__input:focus + .input-field__label[data-v-0613af2d], .input-field__input:not(:placeholder-shown) + .input-field__label[data-v-0613af2d] {\n  inset-block-start: -10px;\n  line-height: 1.5;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: var(--default-grid-baseline) var(--default-grid-baseline) 0 0;\n  background-color: var(--color-main-background);\n  padding-inline: 5px;\n  margin-inline-start: 9px;\n  transition: height var(--animation-quick), inset-block-start var(--animation-quick), font-size var(--animation-quick), color var(--animation-quick);\n}\n.input-field__input:focus + .input-field__label--leading-icon[data-v-0613af2d], .input-field__input:not(:placeholder-shown) + .input-field__label--leading-icon[data-v-0613af2d] {\n  margin-inline-start: 41px;\n}\n.input-field__icon[data-v-0613af2d] {\n  position: absolute;\n  height: var(--default-clickable-area);\n  width: var(--default-clickable-area);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.7;\n}\n.input-field__icon--leading[data-v-0613af2d] {\n  inset-block-end: 0;\n  inset-inline-start: 2px;\n}\n.input-field__icon--trailing[data-v-0613af2d] {\n  inset-block-end: 0;\n  inset-inline-end: 2px;\n}\n.input-field__trailing-button.button-vue[data-v-0613af2d] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  border-radius: var(--border-radius-large);\n}\n.input-field__trailing-button--pill.button-vue[data-v-0613af2d] {\n  border-radius: var(--border-radius-pill);\n}\n.input-field__helper-text-message[data-v-0613af2d] {\n  padding-block: 4px;\n  display: flex;\n  align-items: center;\n}\n.input-field__helper-text-message__icon[data-v-0613af2d] {\n  margin-inline-end: 8px;\n}\n.input-field__helper-text-message--error[data-v-0613af2d] {\n  color: var(--color-error-text);\n}\n.input-field__helper-text-message--success[data-v-0613af2d] {\n  color: var(--color-success-text);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
